import Vue from 'vue';
import Vuex from 'vuex';
import { AcaciaModules } from '@acacia_consultoria/vue-acacia-plugin';

import Settings from './modules/settings';
import Companies from './modules/companies';
import Users from './modules/users';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...AcaciaModules,
    Settings,
    Companies,
    Users,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js